import React, { useEffect } from 'react';
import PageContainer from '@jumbo/components/PageComponents/layouts/PageContainer';
import makeStyles from '@material-ui/core/styles/makeStyles';
import BundleList from './BundleList';
import { useDispatch, useSelector } from 'react-redux';
import { getBundledList, getBundleItemMovies, getComaniesList } from 'redux/actions/Movies';
import { useHistory, useLocation } from 'react-router';
import { Button, Card } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  cardRoot: {
    marginBottom: 6,
  },
}));

const ManageBundle = () => {
  const location = useLocation();
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const params = new URLSearchParams(location.search);

  const parent = params.get('p');
  // const quality = params.get('q');

  const { bundledList, bundleItemMovies, filterBundle } = useSelector(({ movies }) => movies);

  useEffect(() => {
    dispatch(getComaniesList());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getBundledList(parent));
  }, [parent, dispatch]);

  useEffect(() => {
    dispatch(getBundleItemMovies(filterBundle));
  }, [filterBundle, dispatch]);

  const breadcrumbs = [
    { label: 'لیست فیلم‌ها', link: '/' },
    { label: <Button onClick={() => history.goBack()}>بازگشت به مدیریت دانلود</Button> },
  ];

  return (
    <PageContainer breadcrumbs={breadcrumbs} heading={'ساخت باندل'}>
      <Card className={classes.cardRoot}>
        <BundleList title={'باندل شده'} list={bundledList} choiseList={false} />
      </Card>
      <BundleList title={'لیست فیلم ها'} list={bundleItemMovies} choiseList={true} />
    </PageContainer>
  );
};

export default ManageBundle;
